module.exports = __webpack_public_path__ + "img/img-home.eb92b9f9.png";